// src/components/PracticeTest/Toolbar.jsx


import React from 'react';

export default function Toolbar({ onOpenSearch, onSync, isSyncing }) {
    return (
        <div className="toolbar">
            <span className="status-text" style={{ color: '#64748b', fontWeight: '500' }}>
                {isSyncing ? "Syncing..." : "Up to date"}
            </span>
            <div style={{ display: 'flex', gap: '8px' }}>
                <button className="btn-sync" onClick={onOpenSearch}>
                    🔍 Search
                </button>
                <button 
                    className={`btn-sync ${isSyncing ? 'spin' : ''}`} 
                    onClick={onSync}
                    disabled={isSyncing}
                >
                    Sync
                </button>
            </div>
        </div>
    );
}